import React from 'react';
import { Link } from 'react-router-dom';
import NavyLogo from 'assets/images/NavyLogo.svg';

export default function WhiteHeader() {
    const isElderCare = window.location.href.includes('facilities');

    return (
        <Link to={isElderCare ? '/facilities' : '/'}>
            <NavyLogo height={50} width={150} alt="tandem logo" />
        </Link>
    );
}
